// filepath: c:\Users\Usuário\Desktop\Probrain\maratona-web\src\components\Lists\GraphicsAdmin\BarGraphics\index.tsx
import React, { useState, useContext, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import pClasses from "../../ListUsersAndAdmins.module.scss";
import { useTranslation } from "react-i18next";
import RoundButton from "../../../Buttons/RoundButton";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import SessionContext from "../../../../context/sessionContext";

// MUI imports
import { Box, Typography } from "@mui/material";

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface Interface {
  fetchedJourney?: any;
  className?: string;
}

export default function BarGraphics({ className = "", fetchedJourney }: Interface) {
  const { t } = useTranslation();
  const ref: any = React.createRef();
  const cSession = useContext(SessionContext);
  const { user } = cSession ?? {};
  const [content, setContent] = useState<any>(<></>);

  useEffect(() => {
    setContent(
      <>
        <Box
          sx={{
            height: 600,
            overflowX: "auto",
            pl: 0,
            pr: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              minWidth: 1200,
              justifyContent: "flex-start",
              // aplica margin-left negativa para telas pequenas, para deixar mais centralizado o conteúdo
              ml: {
                xs: "-130px",
                sm: "-150px",
                md: "-150px",
                lg: 0,
              }
            }}
          >
            <Box sx={{ width: "fit-content", mt: 4 }}>
              <Box
                sx={{
                  textAlign: {
                    xs: 'left',
                    sm: 'left',
                    md: 'center',
                  },
                  pl: {
                    xs: 25,
                    sm: 48,
                    md: 0,
                  },
                }}
              >
                <Typography style={{ fontWeight: "bold", fontSize: 18, color: "#333" }}>
                  {t("global.tests_scores").toUpperCase()}
                </Typography>
              </Box>
              <Bar
                data={{
                  labels: fetchedJourney?.avaliation.map((test: any) =>
                    t(`tests.${test.test_name}_resume`)
                  ),
                  datasets: [
                    {
                      label: "Acertos Avaliação(%)",
                      data: fetchedJourney?.avaliation.map((test: any) => test.test_score * 10),
                      backgroundColor: "#1D8688",
                      categoryPercentage: 0.8,
                      barPercentage: 0.8,
                    },
                    {
                      label: "Acertos Reavaliação(%)",
                      data: fetchedJourney?.reavaliation.map((test: any) => test.test_score * 10),
                      backgroundColor: "#B5F5E6",
                      categoryPercentage: 0.8,
                      barPercentage: 0.8,
                    },
                  ],
                }}
                options={{
                  responsive: false,
                  maintainAspectRatio: false,
                  indexAxis: "x",
                  layout: {
                    padding: {
                      right: 150,
                      left: 150,
                    },
                  },
                  scales: {
                    x: {
                      title: {
                        display: true,
                        // text: t("global.tests"),
                      },
                      ticks: {
                        maxRotation: 50,
                        minRotation: 50,
                      },
                      grid: {
                        drawTicks: true,
                        drawOnChartArea: false,
                        color: (context) => {
                          return "#000"; // cor dos tracinhos
                        },
                        lineWidth: (context) => {
                          return 2; // espessura dos tracinhos
                        },
                      },
                      border: {
                        color: "#000",
                        width: 2,
                      },
                    },

                    y: {
                      title: {
                        display: true,
                        text: t("global.score"),
                      },
                      ticks: {
                        stepSize: 20,
                      },
                      grid: {
                        drawTicks: true,
                        drawOnChartArea: false,
                        color: (context) => {
                          return "#000"; // cor dos tracinhos
                        },
                        lineWidth: (context) => {
                          return 2; // espessura dos tracinhos
                        },
                      },
                      border: {
                        color: "#000",
                        width: 2,
                      },
                    },
                  },
                  plugins: {
                    title: {
                      display: true,
                      // text: t("global.tests_scores").toUpperCase(),
                      font: {
                        size: 18,
                        weight: "bold"
                      },
                    },
                    legend: {
                      labels: {
                        font: {
                          size: 14,
                          weight: 'bold'
                        },
                      },
                    },
                  },
                }}
                width={1200}
                height={500}
              />
            </Box>
          </Box>
        </Box>
      </>
    );
  }, [fetchedJourney]);

  const pdfDownload = () => {
    const input: any = document.getElementById(ref);
    html2canvas(input).then((canvas) => {
      const pdf = new jsPDF("landscape");
      const imgData = canvas.toDataURL("image/jpeg");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const imgWidth = 250;
      const imgHeight = 150;
      const x = (pdfWidth - imgWidth) / 2;
      const y = 10;
      pdf.addImage(imgData, "PNG", x, y, imgWidth, imgHeight);

      let heightLeft = imgHeight + y - pdfHeight;
      while (heightLeft >= 0) {
        pdf.addPage();
        pdf.addImage(
          imgData,
          "PNG",
          x,
          y - pdfHeight * (Math.floor(heightLeft / pdfHeight) + 1),
          imgWidth,
          imgHeight
        );
        heightLeft -= pdfHeight;
      }

      pdf.save(
        `${user
          ? String(user.registry).replace(".", "_")
          : "BarChart"
        }_GráficoBarras_Audiofoco.pdf`
      );
    });
  };

  return (
    <div className={className + " " + pClasses.TableArea}>
      <RoundButton
        small
        className={pClasses.BtnPdfSecondary}
        text={t("global.print_partial_report")}
        faIcon={faFilePdf}
        title={t("BAIXAR PDF")}
        onClick={() => pdfDownload()}
      />
      <div id={ref}>{content}</div>
    </div>
  );
}